// extracted by mini-css-extract-plugin
export default {"raw-table":"KcmPage_raw-table__s19Va"};